import React, { useState } from "react";
import Executive from "./Executive";
import Cards from "./Cards";
import Expense from "./Expense";
import Ap from "./Ap";
import Invoice from "./Invoice";
import Payment from "./Payment";
import CorporateUser from "./CorporateUser";
import Risk from "./Risk";
import Audit from "./Audit";

<style>
    {`
.hide-scroll::-webkit-scrollbar {
  display: none;
}
`}
</style>

export default function Dashboard() {
    const [activeTab, setActiveTab] = useState("executive-dashboard");
    const tabs = [
        { title: "Executive Dashboard", key: "executive-dashboard" },
        { title: "Cards Analytics", key: "cards-analytics" },
        { title: "Expense Analytics", key: "expense-analytics" },
        { title: "AP Analytics", key: "ap-analytics" },
        { title: "Invoice Analytics", key: "invoice-analytics" },
        { title: "Payment Analytics", key: "payment-analytics" },
        { title: "Corporate & User Analytics", key: "corporate-user-analytics" },
        { title: "Risk & Compliance", key: "risk-compliance" },
        { title: "Audit & Governance", key: "audit-governance" },
    ];

    return (
        <div>
            <div
                style={{
                    display: "flex",
                    marginBottom: "1rem",
                    overflowX: "auto",
                    whiteSpace: "nowrap",
                    WebkitOverflowScrolling: "touch",
                    scrollbarWidth: "none",
                    msOverflowStyle: "none",
                }}
                className="hide-scroll"
            >
                {tabs.map((tab) => (
                    <button
                        key={tab.key}
                        onClick={() => setActiveTab(tab.key)}
                        style={{
                            flexShrink: 0,
                            padding: "6px 16px",
                            background: activeTab === tab.key ? "#0f172a" : "#f3f4f6", 
                            color: activeTab === tab.key ? "#ffffff" : "#475569",
                            border: "none",
                            borderRadius: "9999px",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight: activeTab === tab.key ? 600 : 500,
                            marginRight: "12px",
                            lineHeight: "1.2",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {tab.title}
                    </button>
                ))}
            </div>






            {activeTab === "executive-dashboard" && <Executive />}
            {activeTab === "cards-analytics" && <Cards />}
            {activeTab === "expense-analytics" && <Expense />}
            {activeTab === "ap-analytics" && <Ap />}
            {activeTab === "invoice-analytics" && <Invoice />}
            {activeTab === "payment-analytics" && <Payment />}
            {activeTab === "corporate-user-analytics" && <CorporateUser />}
            {activeTab === "risk-compliance" && <Risk />}
            {activeTab === "audit-governance" && <Audit />}
        </div>
    );
}



